import { render, staticRenderFns } from "./BorderProperty.vue?vue&type=template&id=f397bbba&"
import script from "./BorderProperty.vue?vue&type=script&lang=js&"
export * from "./BorderProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports